
import { colors } from "oolib"
import styled, { css } from "styled-components"

export const StyledAspectRatioWrapper = styled.div`
${({width, height}) => `
  width: ${width};
  height: ${height};
`}
border-radius: ${({containerShape}) => containerShape === 'circle' && '50%' };
overflow: hidden;
background-color: ${({invert}) => invert ? colors.greyColor90 : colors.greyColor5};
  ${({disableImageBorder, invert}) => !disableImageBorder && css`
    border: 2px solid ${invert ? colors.greyColor90 : colors.greyColor5}
  `};
`
